import { ExternalLink } from 'react-feather';
import { Trans, useTranslation } from 'react-i18next';

import UI from '../UI';
import useLocale from '../useLocale';

interface Payment {
  id: string;
  amount: number;
  bank_name?: string | null;
  bank_iban?: string | null;
  transfer_reference?: string | null;
  status_url?: string | null;
}

export interface BankTransferInstructionsProps {
  payment: Payment;
  email?: string;
}

const BankTransferInstructions = ({ payment, email }: BankTransferInstructionsProps) => {
  const { t } = useTranslation('common');
  const { formatCurrency } = useLocale();

  return (
    <UI.Info icon={<UI.Icons.Pending />}>
      <UI.H5>
        {t('bank_transfer_instructions.payment_instructions')}
      </UI.H5>
      <UI.Paragraph>
        {t('bank_transfer_instructions.payment_instructions_description')}
      </UI.Paragraph>
      <UI.GridContainer sc={{ columns: '2fr 3fr', gutter: 0.5, mb: 0.5 }}>
        <UI.Div>
          {t('bank_transfer_instructions.amount')}
        </UI.Div>
        <UI.Div sc={{ strong: true }} style={{ textDecoration: 'underline' }}>
          {formatCurrency(payment.amount)}
        </UI.Div>
      </UI.GridContainer>
      <UI.GridContainer sc={{ columns: '2fr 3fr', gutter: 0.5, mb: 0.5 }}>
        <UI.Div>
          {t('bank_transfer_instructions.beneficiary')}
        </UI.Div>
        <UI.Div sc={{ strong: true }} style={{ textDecoration: 'underline' }}>
          {payment.bank_name}
        </UI.Div>
      </UI.GridContainer>
      <UI.GridContainer sc={{ columns: '2fr 3fr', gutter: 0.5, mb: 0.5 }}>
        <UI.Div>
          {t('bank_transfer_instructions.iban')}
        </UI.Div>
        <UI.Div sc={{ strong: true }} style={{ textDecoration: 'underline' }}>
          {payment.bank_iban}
        </UI.Div>
      </UI.GridContainer>
      <UI.GridContainer sc={{ columns: '2fr 3fr', gutter: 0.5 }}>
        <UI.Div>
          {t('bank_transfer_instructions.payment_reference')}
        </UI.Div>
        <UI.Div sc={{ strong: true }} style={{ textDecoration: 'underline' }}>
          {payment.transfer_reference}
        </UI.Div>
      </UI.GridContainer>

      {email && (
        <UI.Paragraph sc={{ mt: 3, mb: 0 }}>
          <Trans
            ns="common"
            i18nKey="bank_transfer_instructions.invoice_has_beent_sent_to_email"
            values={{ email }}
          >
            <UI.Strong />
          </Trans>
        </UI.Paragraph>
      )}

      {payment.status_url && (
        <UI.Paragraph sc={{ mt: 3, mb: 0 }}>
          <UI.A href={payment.status_url} target="_blank" rel="noopener noreferrer">
            {t('bank_transfer_instructions.check_status')}
            {' '}
            <UI.Icon>
              <ExternalLink />
            </UI.Icon>
          </UI.A>
        </UI.Paragraph>
      )}
    </UI.Info>
  );
};

export default BankTransferInstructions;
